{
  "modal": {
    "categoryTierModal": {
      "create": "Create",
      "delete": "Delete",
      "deleteCategoryDescription": "The category is used by the documents below. A document must always belong to a category, so choose a new category for each document before deleting.",
      "deleteCategoryTitle": "Delete \"{{title}}\"",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Description is empty",
      "documentsRemaining": "{{count}} remaining",
      "documentsToMove": "Documents to move",
      "documentTitle": "Document title",
      "moveDocumentsAndDelete": "Move documents and delete \"{{title}}\"",
      "moveToCategory": "Move to category",
      "titleLabel": "Title",
      "titlePlaceholder": "Please enter title...",
      "update": "Update"
    },
    "archiveProject": {
      "title": "Archive project",
      "confirmDescription": "Are you sure you want to archive this project including all its document versions?"
    },
    "infoReaders": {
      "description": "This is a list of users which are as assigned readers of this document, and their status. Only the owner of this document can remove the reader.",
      "title": "Readers information"
    },
    "inviteUsers": {
      "subText": "Users will get invitations in their emails to read and accept the document.",
      "title": "Invite users"
    },
    "tags": {
      "manageTags": "Manage tags",
      "newTag": "New tag",
      "selectTag": "Select tag",
      "searchOrCreate": "Search or create tags",
      "existingTags": "Existing tags",
      "searchToFindOrCreate": "Search to find or create tags"
    },
    "editDocumentTitle": {
      "placeholder": "Enter new title",
      "duplicateWarning": "There already is a document named"
    },
    "officeDesktop": {
      "trackChangesDisabledTitle": "Track changes is not enabled.",
      "trackChangesDisabledDescription": "Enable track changes to ensure changes are visible.",
      "cancel": "Cancel"
    }
  }
}
